import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Modal from "~/js/common/modal";
import HeaderMenu from "./headerMenu";
import Selector from "./selector";
import Tooltip from "~/js/common/tooltip";
import _each from "lodash/each";
import _filter from "lodash/filter";
import _without from "lodash/without";
import _compact from "lodash/compact";

import DropdownSelector from "~/js/common/dropdownSelector";
import noUiSlider from "nouislider";
export default class ECSearchMain {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    this.header = new Header();
    this.footer = new Footer();
    this.modal = new Modal();

    this.headerMenu = new HeaderMenu();
    this.selector = new Selector();
    this.tooltip = new Tooltip();
    store.dispatch("init");

    // ドロップダウン制御を共通クラスに委譲
    const searchEl = document.querySelector('.ec-search');
    if (searchEl) {
      this.dropdown = new DropdownSelector(searchEl, { prefix: '' });
    }

    this.setupClear();
    this.setupFocusEvent();
    this.clickOutside();
    this.setupPriceSlider();
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }

  //focusイベント
  setupFocusEvent() {
    const optionswraps = document.querySelectorAll(".js-brand-option, .js-item-option, .js-color-option");
    _each(optionswraps, (optionswrap, index) => {
      const title = optionswrap.querySelector(".js-searchoptions");
      let _options = title.getAttribute("data-target");
      let _optionsDom = document.querySelector(_options);
      const groupLinks = _optionsDom ? _optionsDom.querySelectorAll('.js-option') : '';
      if (groupLinks.length) {
        const firstItem = groupLinks[0]
        const lastItem = groupLinks[groupLinks.length - 1]
        firstItem.addEventListener('keydown', event => {
          if (event.keyCode === 9 && event.shiftKey) {
            this.closeAllOptions();
          }
        })
        lastItem.addEventListener('keydown', event => {
          if (event.keyCode === 9 && !event.shiftKey) {
            this.closeAllOptions();
          }
        })
      }
      _optionsDom.addEventListener(
        "focusin", (event) => {
          const focusedOption = event.target;
          if (focusedOption && focusedOption.classList.contains('js-option')) {
            this.updateAriaActiveDescendant(title, focusedOption);
          }
        }
      );

      _optionsDom.addEventListener(
        "focusout",
        function (event) {
          const nextFocused = event.relatedTarget;
          // Do not close if focus is moving to the trigger button for this listbox
          const isMovingToTitle = nextFocused === title || (title && title.contains && title.contains(nextFocused));
          if (!_optionsDom.contains(nextFocused) && !isMovingToTitle) {
            this.closeAllOptions();
          }
        }.bind(this)
      );

      _optionsDom.addEventListener(
        "keydown",
        function (event) {
          // ESCキーが押された時
          if (event.key === "Escape") {
            this.closeAllOptions();
            // return focus to trigger
            if (title && typeof title.focus === 'function') {
              title.focus();
            }
            return;
          }

          // Arrow/Page navigation within listbox
          const isArrowDown = event.key === "ArrowDown" || event.keyCode === 40;
          const isArrowUp = event.key === "ArrowUp" || event.keyCode === 38;
          const isPageDown = event.key === "PageDown" || event.keyCode === 34;
          const isPageUp = event.key === "PageUp" || event.keyCode === 33;
          const isHome = event.key === "Home" || event.keyCode === 36;
          const isEnd = event.key === "End" || event.keyCode === 35;

          if (isArrowDown || isArrowUp || isPageDown || isPageUp || isHome || isEnd) {
            const options = _optionsDom.querySelectorAll('.js-option');
            if (!options || options.length === 0) return;

            const optionsArr = Array.prototype.slice.call(options);
            const active = document.activeElement;
            let idx = optionsArr.indexOf(active);

            // If focus is on the listbox itself, start from first/last appropriately
            if (idx === -1) {
              if (isArrowDown || isPageDown || isHome) {
                idx = 0;
              } else if (isArrowUp || isPageUp || isEnd) {
                idx = optionsArr.length - 1;
              }
              optionsArr[idx].focus();
              this.updateAriaActiveDescendant(title, optionsArr[idx]);
              event.preventDefault();
              return;
            }

            if (isArrowDown) {
              event.preventDefault();
              const next = Math.min(idx + 1, optionsArr.length - 1);
              optionsArr[next].focus();
              this.updateAriaActiveDescendant(title, optionsArr[next]);
              return;
            }
            if (isArrowUp) {
              event.preventDefault();
              const prev = Math.max(idx - 1, 0);
              optionsArr[prev].focus();
              this.updateAriaActiveDescendant(title, optionsArr[prev]);
              return;
            }
            if (isPageDown || isEnd) {
              event.preventDefault();
              const lastOption = optionsArr[optionsArr.length - 1];
              lastOption.focus();
              this.updateAriaActiveDescendant(title, lastOption);
              return;
            }
            if (isPageUp || isHome) {
              event.preventDefault();
              const firstOption = optionsArr[0];
              firstOption.focus();
              this.updateAriaActiveDescendant(title, firstOption);
              return;
            }
          }
        }.bind(this)
      );
    });
  }

  /**
   * Update aria-activedescendant on the trigger button
   * This informs screen readers which option is currently focused
   * @param {Element} triggerButton - The combobox trigger button
   * @param {Element} activeOption - The currently focused option
   */
  updateAriaActiveDescendant(triggerButton, activeOption) {
    if (triggerButton && activeOption && activeOption.id) {
      triggerButton.setAttribute('aria-activedescendant', activeOption.id);
    }
  }

  // 選択肢表示の制御
  setupOptions() {
    const titles = document.querySelectorAll(".js-searchoptions");
    _each(titles, (title, index) => {
      title.addEventListener("click", (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const _options = target.getAttribute("data-target");

        if (_options) {
          this.closeAllOptions(_options);
          const _optionsDom = document.querySelector(_options);
          // オプションが開いている場合は閉じる
          const _categories = document.querySelectorAll(".js-option-category");
          _each(_categories, (category) => {
            let _target = category.getAttribute("data-category");
            let _targetDom = document.querySelector(_target);
            if (_target && _targetDom) {
              _targetDom.classList.remove("open");
            }
          });
          let result = _optionsDom.classList.toggle("active");

          // 開いているSelectBoxのスタイルを変更する
          if (result) {
            target.classList.add("open");
            target.setAttribute('aria-expanded', 'true');
            const selectedOption = _optionsDom.querySelector('.js-option.active') || _optionsDom.querySelector('.js-option');
            if (selectedOption && selectedOption.id) {
              target.setAttribute('aria-activedescendant', selectedOption.id);
            }
          } else {
            target.classList.remove("open");
            target.setAttribute('aria-expanded', 'false');
            target.removeAttribute('aria-activedescendant');
          }
          if (_optionsDom.classList.contains("active")) {
            _optionsDom.focus();
          }
        }
      });
    });
  }

  closeAllOptions(exclude) {
    const titles = document.querySelectorAll(".js-searchoptions");
    _each(titles, (title, index) => {
      const _options = title.getAttribute("data-target");
      if (_options === exclude) {
        return;
      }
      if (_options) {
        title.classList.remove("open");
        title.setAttribute('aria-expanded', 'false');
        title.removeAttribute('aria-activedescendant');
        const _optionsDom = document.querySelector(_options);
        _optionsDom.classList.remove("active");
      }
    });
  }

  clickOutside () {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.js-list-option') && !e.target.closest('.js-searchoptions') ) {
        this.closeAllOptions()
      }
    })
  }

  //カテゴリの開閉を制御
  setupOptionCategory() {
    const categories = document.querySelectorAll(".js-option-category");
    _each(categories, (category) => {
      category.addEventListener("click", (event) => {
        const _target = category.getAttribute("data-category");
        const targetDOM = document.querySelector(_target);
        if (targetDOM) {
          targetDOM.classList.toggle("open");
          if (targetDOM.classList.contains('open')) {
            category.setAttribute('aria-expanded', 'true')
          } else {
            category.setAttribute('aria-expanded', 'false')
          }
        }
      });
    });
  }

  // セレクトオプション選択時の制御
  setupOptionItems() {
    const options = document.querySelectorAll(".js-option");
    const closes = document.querySelectorAll(".js-closeoption");
    if (options) {
      _each(options, (option, index) => {
        option.addEventListener("click", (event) => {
          event.preventDefault();
          // ◯◯すべて があるときの処理
          if (option.classList.contains("js-option-all")) {
            this.selectGroupAll(option);
          } else {
            // ◯◯すべて が選択されている場合は、それを解除する
            this.clearGroupAll(option);
          }
          this.execOptionItem(option);

          /**
           * TODO: kanehori add code
           * カテゴリ選択後に閉じられないためサブミットできないバグ対応
           *
           * 複数選択仕様への調整に伴い、
           * setupOptions 内で都度閉じるように調整
           */
          //if (event.target.closest(".open")) {
          //  event.target.closest(".open").classList.remove("open");
          //}
        });

        // Keyboard support: Enter/Space selects option
        option.addEventListener("keydown", (event) => {
          const isEnter = event.key === "Enter" || event.keyCode === 13;
          const isSpace = event.key === " " || event.key === "Spacebar" || event.keyCode === 32;
          if (isEnter || isSpace) {
            event.preventDefault();
            // Reuse click handler logic
            option.click();
          }
        });
      });
    }
    if (closes) {
      _each(closes, (close, index) => {
        close.addEventListener("click", (event) => {
          event.preventDefault();
          this.closeAllOptions();
        });
      });
    }
  }

  /**
   * ◯◯すべて（グループオール）が選択されたときの処理
   * @param target
   */
  selectGroupAll(target) {
    const groupOptions = target.parentNode.querySelectorAll(".js-option");
    let nodeList = _filter(groupOptions, (option) => {
      return !option.classList.contains("js-option-all");
    });
    // グループ内の選択肢をすべて解除
    this.clearOptionInGroup(nodeList);
  }

  clearOptionInGroup(nodeList) {
    nodeList.forEach((node) => {
      if (node.classList.contains("active")) {
        node.classList.remove("active");
        node.setAttribute("aria-selected", "false")
        // ここでactiveなグループのstoreの値を更新する
        store.dispatch("setSearchOptionItem", {
          target: node.getAttribute("data-target"),
          label: node.getAttribute("data-label"),
          value: node.getAttribute("data-value")
        });
      }
    });
  }

  /**
   * グループオール選択肢の選択を解除
   * @param target
   */
  clearGroupAll(target) {
    let allName = target.getAttribute("data-groupall");
    let groupAll = document.querySelector(allName);
    if (groupAll) {
      if (groupAll.classList.contains("active")) {
        groupAll.classList.remove("active");
        groupAll.setAttribute("aria-selected", "false")
        store.dispatch("setSearchOptionItem", {
          target: groupAll.getAttribute("data-target"),
          label: groupAll.getAttribute("data-label"),
          value: groupAll.getAttribute("data-value")
        });
      }
    }
  }

  /**
   * オプション選択
   * @param option
   * @param clearOthers 真であれば他の選択肢をすべて解除
   */
  execOptionItem(option, clearOthers = false) {
    const target = option.getAttribute("data-target");
    const value = option.getAttribute("data-value");
    const label = option.getAttribute("data-label");
    const targetDom = document.querySelector(target);
    const optionsTitle = targetDom.querySelector(".js-searchoptions");
    const defaultOption = targetDom.querySelector(".js-default");

    if (clearOthers) {
      this.clearOptionItem(targetDom);
    }

    store.dispatch("setSearchOptionItem", {
      target: target,
      label: label,
      value: value
    });
    if (value === "") {
      // すべて 選択時
      this.clearOptionItem(targetDom);
    } else {
      // 「すべて」選択を解除
      if (defaultOption) {
        defaultOption.classList.remove("active");
        option.setAttribute("aria-selected", "false")
      }
    }
    if (option.classList.contains("active")) {
      option.classList.remove("active");
      option.setAttribute("aria-selected", "false")
      // すべてのオプション選択解除時には「すべて」を選択状態に
      const options = targetDom.querySelectorAll(".js-option");
      let all = true;
      _each(options, (option) => {
        if (option.classList.contains("active")) {
          all = false;
        }
      });
      if (all) {
        defaultOption.classList.add("active");
        defaultOption.setAttribute("aria-selected", "true")
      }
    } else {
      option.classList.add("active");
      option.setAttribute("aria-selected", "true")
    }

    // optionsTitle.focus();
    // オプション選択時に閉じる仕様を外す
    /// this.closeAllOptions();
  }

  /**
   * オプション選択解除
   * @param targetDom
   */
  clearOptionItem(targetDom) {
    let brothers = targetDom.querySelectorAll(".js-option"); //option.parentNode.children;
    // 選択されたノードの解除機能
    if (brothers) {
      _each(brothers, (brother) => {
        brother.classList.remove("active");
        brother.setAttribute("aria-selected", "false")
      });
    }
  }

  /**
   * クリアボタン押下時
   */
  setupClear() {
    const clearbutton = document.querySelector(".js-clear");
    if (clearbutton) {
      clearbutton.addEventListener("click", () => {
        if (this.dropdown) {
          this.dropdown.clearAllSelections();
        }

        // 価格スライダーをリセット
        if (this.priceSlider && this.priceSliderConfig) {
          this.priceSlider.set([this.priceSliderConfig.defaultMin, this.priceSliderConfig.defaultMax]);
        }
      });
    }
  }

  /**
   * 価格スライダーのセットアップ
   */
  setupPriceSlider() {
    const sliderElement = document.querySelector('.js-price-slider');
    if (!sliderElement) {
      this.priceSlider = null;
      return;
    }

    const minInput = document.querySelector('.js-price-min-input');
    const maxInput = document.querySelector('.js-price-max-input');
    const minPriceDisplay = document.querySelector('.min-price');
    const maxPriceDisplay = document.querySelector('.max-price');

    // 設定値（上限はdata属性から取得、未設定または0の場合はデフォルト値を使用）
    const maxPriceFromSettings = parseInt(sliderElement.dataset.maxPrice, 10);
    const sliderMax = (isNaN(maxPriceFromSettings) || maxPriceFromSettings <= 0) ? 5000 : maxPriceFromSettings;
    const PRICE_SLIDER_CONFIG = {
      step: 500,
      min: 0,
      max: sliderMax,
      defaultMin: 0,
      defaultMax: sliderMax
    };
    this.priceSliderConfig = PRICE_SLIDER_CONFIG;

    // URLパラメータから初期値を取得（price_1/price_2 と filter.v.price.gte/lte の両方に対応）
    const urlParams = new URLSearchParams(window.location.search);

    // URLパラメータから価格を取得（0も有効な値として扱う）
    const minPriceParam = urlParams.get('filter.v.price.gte') || urlParams.get('price_1');
    const maxPriceParam = urlParams.get('filter.v.price.lte') || urlParams.get('price_2');

    // 価格パラメータのパース処理（空文字列とNaNを考慮）
    const parsePrice = (param, defaultValue) => {
      if (!param || param === '') return defaultValue;
      const parsed = parseInt(param, 10);
      return isNaN(parsed) ? defaultValue : parsed;
    };

    const minPrice = parsePrice(minPriceParam, PRICE_SLIDER_CONFIG.defaultMin);
    const maxPrice = parsePrice(maxPriceParam, PRICE_SLIDER_CONFIG.defaultMax);

    // noUiSlider初期化
    this.priceSlider = noUiSlider.create(sliderElement, {
      start: [minPrice, maxPrice],
      connect: true,
      step: PRICE_SLIDER_CONFIG.step,
      range: {
        'min': PRICE_SLIDER_CONFIG.min,
        'max': PRICE_SLIDER_CONFIG.max
      },
      format: {
        to: (value) => Math.round(value),
        from: (value) => Number(value)
      }
    });

    // スライダー値変更時の処理
    this.priceSlider.on('update', (values) => {
      const minValue = Number(values[0]);
      const maxValue = Number(values[1]);

      // 価格表示を更新（ロケール明示）
      minPriceDisplay.textContent = `$${minValue.toLocaleString('en-US')}`;
      maxPriceDisplay.textContent = `$${maxValue.toLocaleString('en-US')}`;

      // 隠し入力フィールドに値を設定
      minInput.value = minValue;
      maxInput.value = maxValue;
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ECSearchMain();
});
